export * from './animate-size-to-auto';
